module.exports = Object.freeze({
  BASE_URL: process.env.API_BASE_URL,
  LOGO_URL: process.env.API_BASE_URL + '/files',
});